import script from "./PageEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./PageEnd.vue?vue&type=script&setup=true&lang=js"

import "./PageEnd.vue?vue&type=style&index=0&id=b766d04c&lang=less"

const __exports__ = script;

export default __exports__